module.exports = __webpack_public_path__ + "static/media/dashboard.93310a29.svg";